import terminalAudit from './terminal_audit.vue';

export default terminalAudit;
